import { GenericMedicalList } from "./GenericMedicalList";

const CATEGORIES = [
  "Annual Physical", "Dental Cleaning and Exam", "Vision Exam", "Hearing Exam",
  "Colonoscopy", "Mammogram", "Cervical Cancer Screening (Pap)", "Prostate Screening (PSA)",
  "Skin Cancer Screening", "Lung Cancer Screening (LDCT)",
  "Bone Density (DEXA)", "AAA Screening (Abdominal Aortic Aneurysm)",
  "Hepatitis C Screening", "HIV Screening", "STI Screening",
  "Diabetes Screening (Fasting Glucose)", "Lipid Panel", "Blood Pressure Check",
  "Depression Screening (PHQ-9)", "Anxiety Screening (GAD-7)",
  "Substance Use Screening (AUDIT-C)", "Fall Risk Assessment",
];
const STATUSES = ["Due", "Overdue", "Completed", "Declined", "Not Applicable"];

const DEFAULT = { category: "", status: "Due", last_done_date: "", next_due_date: "",
                  provider: "", result_summary: "", frequency_months: "", notes: "" };

const COLUMNS = [
  { key: "category", label: "Category" },
  { key: "status", label: "Status", format: "chip" },
  { key: "last_done_date", label: "Last Done", format: "date" },
  { key: "next_due_date", label: "Next Due", format: "date" },
  { key: "provider", label: "Provider" },
];

const FIELDS = [
  { key: "category", label: "Screening or Preventive Item", type: "select", options: CATEGORIES, required: true, span: 2 },
  { key: "status", label: "Status", type: "select", options: STATUSES, required: true },
  { key: "frequency_months", label: "Recommended frequency (months)", type: "number" },
  { key: "last_done_date", label: "Last Completed", type: "date" },
  { key: "next_due_date", label: "Next Due", type: "date" },
  { key: "provider", label: "Ordering or Performing Provider" },
  { key: "result_summary", label: "Result Summary", type: "textarea", span: 2 },
  { key: "notes", label: "Notes", type: "textarea", span: 2 },
];

export default function PreventiveCare({ client }) {
  return (
    <GenericMedicalList
      client={client}
      title="Preventive Care and Health Maintenance"
      subtitle="Cancer screenings, physicals, dental, vision, and behavioral health screeners."
      endpointList={(cid) => `/clients/${cid}/preventive-care`}
      endpointCreate={(cid) => `/clients/${cid}/preventive-care`}
      endpointUpdate={(id) => `/preventive-care/${id}`}
      endpointDelete={(id) => `/preventive-care/${id}`}
      columns={COLUMNS}
      formFields={FIELDS}
      defaultForm={DEFAULT}
      testPrefix="preventive-care"
      emptyText="No preventive care items tracked"
    />
  );
}
